import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// styles
import styles from './index.module.scss'

const UpcomingEventCard = ({ data }) => {
  const router = useRouter()

  // Format date to "Wed • Oct 01 • 7:30PM"
  const formatEventDate = dateString => {
    if (!dateString) return ''

    const date = new Date(dateString)
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const dayName = days[date.getDay()]
    const month = months[date.getMonth()]
    const day = String(date.getDate()).padStart(2, '0')

    let hours = date.getHours()
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12

    return `${dayName} • ${month} ${day} • ${hours}:${minutes}${ampm}`
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer} onClick={() => router.push(data.items[0].url)}>
        <ImageWithFoster
          src={data.items[0].image}
          className="w-full h-full overflow-hidden object-cover rounded-[8px]"
        />
      </div>
      <div className="w-full mt-[15px]">
        <div className={styles.eventDate}>{formatEventDate(data.items[0].date)}</div>
      </div>
      <div className="w-full mt-[5px]">
        <div className={styles.eventName}>
          {data.name}
          {/* • {data.description} */}
        </div>
      </div>
      <div className="w-full mt-[5px]">
        <div className={styles.eventLocation}>{data.items[0].location}</div>
      </div>
      <div className="w-full mt-[5px]">
        <div className={styles.eventHost}>Posted by {data.items[0].host}</div>
      </div>
    </div>
  )
}

export default UpcomingEventCard
